<template>
    <v-app>
        <v-main class="bg-grey-lighten-4">
            <v-container class="d-flex" style="height: 100vh; align-items: center; justify-content: center;">
                <router-view />
            </v-container>
        </v-main>
    </v-app>
</template>